var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(!_vm.isSSO),expression:"!isSSO"}],attrs:{"id":"app"}},[(_vm.isLogin && _vm.isSSO)?_c('DashBoard'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }